import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "24px",
    padding: theme.spacing(2),
    background:
      theme.palette.type === "light"
        ? "rgba(255, 255, 255, 0.9)"
        : "rgba(30, 30, 60, 0.9)",
    backdropFilter: "blur(12px)",
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: "400px",
  },
  header: {
    display: "flex",
    justifyContent: "flex-end",
  },
  content: {
    textAlign: "center",
    padding: theme.spacing(2, 3, 4),
  },
  iconContainer: {
    width: "80px",
    height: "80px",
    borderRadius: "22px",
    background: "linear-gradient(135deg, #0B207D 0%, #3B78FF 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px",
    boxShadow: "0 10px 20px rgba(11, 32, 125, 0.2)",
  },
  appIcon: {
    color: "#fff",
    fontSize: "40px",
  },
  title: {
    fontWeight: 800,
    marginBottom: theme.spacing(1),
    fontSize: "1.5rem",
  },
  description: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
    lineHeight: 1.6,
  },
  benefitList: {
    textAlign: "left",
    marginBottom: theme.spacing(4),
    "& > div": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      fontSize: "0.9rem",
      color: theme.palette.text.primary,
    },
  },
  checkIcon: {
    color: theme.palette.success.main,
    fontSize: "1.2rem",
  },
  installButton: {
    borderRadius: "16px",
    padding: "12px 24px",
    fontWeight: "bold",
    textTransform: "none",
    fontSize: "1rem",
    background: "linear-gradient(135deg, #0B207D 0%, #3B78FF 100%)",
    color: "#fff",
    "&:hover": {
      background: "linear-gradient(135deg, #08165A 0%, #2A5DCC 100%)",
    },
  },
}));

const PWAModal = ({ open, onClose, onInstall }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      fullScreen={isMobile}
      scroll="body"
    >
      <Box className={classes.header}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent className={classes.content}>
        <Box className={classes.iconContainer}>
          <GetAppIcon className={classes.appIcon} />
        </Box>
        <Typography className={classes.title}>Instalar AtendeChat PRO</Typography>
        <Typography className={classes.description}>
          Leve sua produtividade para o próximo nível com nosso aplicativo nativo.
        </Typography>

        <Box className={classes.benefitList}>
          <Box>
            <CheckCircleOutlineIcon className={classes.checkIcon} />
            <Typography variant="body2">Acesso rápido pela tela inicial</Typography>
          </Box>
          <Box>
            <CheckCircleOutlineIcon className={classes.checkIcon} />
            <Typography variant="body2">Notificações mais rápidas e estáveis</Typography>
          </Box>
          <Box>
            <CheckCircleOutlineIcon className={classes.checkIcon} />
            <Typography variant="body2">Interface otimizada e em tela cheia</Typography>
          </Box>
          <Box>
            <CheckCircleOutlineIcon className={classes.checkIcon} />
            <Typography variant="body2">Menor consumo de bateria e dados</Typography>
          </Box>
        </Box>

        <Button
          fullWidth
          variant="contained"
          className={classes.installButton}
          onClick={onInstall}
          startIcon={<GetAppIcon />}
        >
          Instalar Agora
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PWAModal;
